// extracted by mini-css-extract-plugin
export default {"site":"day_site__qAG9N","homeLink":"day_homeLink__1Jq7N","wavePanel":"day_wavePanel__QU2ZT","waveEntity":"day_waveEntity__3sX5-","wave":"day_wave__EBckj"};